import { queryOptions } from "@tanstack/react-query";
import { getWaitlistByScheduleV2 } from "hooks/api/waitlist-v2";

export const waitlistByScheduleV2Options = (
  schedule_id: string,
  occurrence_timestamp: string,
) =>
  queryOptions({
    queryKey: ["waitlist-v2", "schedule", schedule_id, occurrence_timestamp],
    queryFn: () => getWaitlistByScheduleV2(schedule_id, occurrence_timestamp),
    enabled: !!schedule_id && !!occurrence_timestamp,
  });
